var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('quill-editor',{ref:"myTextEditor",staticClass:"quill",attrs:{"content":_vm.content,"options":_vm.editorOption},on:{"change":function($event){_vm.onEditorChange($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }